export const FETCH_UPDATE_PROJECT_REQUEST = 'FETCH_UPDATE_PROJECT_REQUEST'
export const FETCH_UPDATE_PROJECT_SUCCESS = 'FETCH_UPDATE_PROJECT_SUCCESS'
export const FETCH_UPDATE_PROJECT_FALUIRE = 'FETCH_UPDATE_PROJECT_FALUIRE'
